import { useNavigate } from 'react-router-dom'

import { Box, Link, Text } from '@factorialco/deprecated-design-system'
import { FetchWorkedTimesDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { DEFAULT_PERIOD_TYPE } from 'modules/attendance/components/TimeTracking/Layout/form'
import { RequestTypes } from 'modules/attendance/store/models/EditTimesheetRequest'

import type { CollapseContentData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/AttendanceApprovals/types'
import CreateShiftBlock from './CreateShiftBlock'
import DeleteShiftBlock from './DeleteShiftBlock'
import UpdateShiftBlock from './UpdateShiftBlock'

interface Props {
  collapseContentData: CollapseContentData
}

const renderRequestTypeBlock = (data: CollapseContentData, minutes: number) => {
  if (data.requestType === RequestTypes.createShift) {
    return (
      <CreateShiftBlock
        minutes={minutes}
        clockIn={data.newClockIn}
        clockOut={data.newClockOut}
        employeeName={data.ownerName}
        date={data.date}
        locationType={data.newLocationType}
        observations={data.newObservations}
        newIsBreak={data.newIsBreak}
        newBreakName={data.newBreakName}
        newBreakPaid={data.newBreakPaid}
      />
    )
  }
  if (data.requestType === RequestTypes.updateShift) {
    return (
      <UpdateShiftBlock
        minutes={minutes}
        originalClockIn={data.originalClockIn}
        newClockIn={data.newClockIn}
        originalClockOut={data.originalClockOut}
        newClockOut={data.newClockOut}
        originalLocationType={data.originalLocationType}
        newLocationType={data.newLocationType}
        originalObservations={data.originalObservations}
        newObservations={data.newObservations}
        newIsBreak={!!data.newIsBreak}
        originalBreakName={data.originalBreakName}
        newBreakName={data.newBreakName}
        originalBreakPaid={data.originalBreakPaid}
        newBreakPaid={data.newBreakPaid}
        originalBreakId={data.originalBreakId}
        newBreakId={data.newBreakId}
        employeeName={data.ownerName}
        date={data.date}
      />
    )
  }
  if (data.requestType === RequestTypes.deleteShift) {
    return (
      <DeleteShiftBlock
        minutes={minutes}
        employeeName={data.ownerName}
        date={data.date}
        clockIn={data.originalClockIn}
        clockOut={data.originalClockOut}
        isBreak={!!data.originalIsBreak}
        breakName={data.originalBreakName}
      />
    )
  }
}

const RightBlock = ({ collapseContentData }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { data } = useQuery(FetchWorkedTimesDocument, {
    variables: {
      employeeIds: [collapseContentData.employeeId],
      startOn: collapseContentData.referenceDate || collapseContentData.date,
      endOn: collapseContentData.referenceDate || collapseContentData.date,
    },
  })
  const workedTimes = data?.attendance?.workedTimesConnection?.nodes ?? []
  const minutes = workedTimes.reduce((acc, workedTime) => acc + workedTime.minutes, 0)

  if (!collapseContentData.year || !collapseContentData.month) {
    return null
  }

  return (
    <Box width="full" gap="s24">
      <Text.Normal weight="bold">
        {i18n.t('dashboard.todo.approvals.attendance.right_block_title')}
      </Text.Normal>
      {renderRequestTypeBlock(collapseContentData, minutes)}
      <Box justifyContent="flexEnd" width="full" flexDirection="row" textAlign="right">
        <Link.Touchable
          expand
          onClick={() => {
            navigate(
              navigation.timeTracking.employee.periodTypeYearMonthDayEmployeeId.fullPath({
                periodType: DEFAULT_PERIOD_TYPE,
                year: Number(collapseContentData.year),
                month: Number(collapseContentData.month),
                day: moment().day(),
                employeeId:
                  collapseContentData.employeeId ?? Number(collapseContentData.employeeId),
              })
            )
          }}
        >
          {i18n.t('dashboard.todo.approvals.attendance.link', {
            employee: collapseContentData.ownerName,
          })}
        </Link.Touchable>
      </Box>
    </Box>
  )
}

export default RightBlock
